import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=41e2f29c&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=41e2f29c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e2f29c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41e2f29c')) {
      api.createRecord('41e2f29c', component.options)
    } else {
      api.reload('41e2f29c', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=41e2f29c&scoped=true&", function () {
      api.rerender('41e2f29c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2kr7cdtEzUAFl/JS/comp/GuestBox.vue"
export default component.exports